import React, { useEffect, useState } from 'react'
import { Formik, useFormik } from 'formik';
import * as Yup from "yup";
import { Modal } from '@mui/material';
import Button from "../../../components/common/button/Button"
import TextInput from '../../../components/common/input/TextInput';
import InputSelect from "../../../components/common/input/InputSelect"
import styled from './CustomerEdit.module.css'
import callApi from '../../../services/api/apiClient';
import { useToast } from '../../../components/toast/Toast';

const CustomerEditValidationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    code: Yup.string(),
    phone: Yup.string(),
    address: Yup.string(),
});

const CustomerEdit = ({ isOpen, onClose, data, isEdit, customer_id }) => {
    console.log("Data...", data)
    const [selectedState, setSelectedState] = useState(null);
    const [selectedTownship, setSelectedTownship] = useState(null)
    const [states, setStates] = useState([]);
    const [townships, setTownships] = useState([]);
    const { showToast } = useToast()

    useEffect(() => {
        getAllLocations()
        if (data) {
            const defaultValues = {
                name: data?.name || "",
                code: data?.code || "",
                phone: data?.mobile || "",
                address: data?.street || ""
            };
            formik.setValues(defaultValues);
            setSelectedState(data?.state?.id)
            setSelectedTownship(data?.township?.id)
        }

    }, [data, customer_id])

    const getAllLocations = () => {
        callApi('others/getAllLocations')
            .loadingGroup('createCustomer')
            .execute()
            .then(res => {
                setStates(res[0]?.state_ids)
                res[0]?.state_ids?.forEach((state, index) => {
                    if (state.id === data?.state?.id)
                        setTownships(state?.township_ids);
                });
            });
    };
    const formik = useFormik({
        initialValues: {
            name: "",
            code: "",
            phone: "",
            address: ""
        },
        validationSchema: CustomerEditValidationSchema,
        onSubmit: (values, actions) => {
            const bodyData = {
                name: values?.name,
                code: values?.code,
                phone: values?.phone,
                street: values?.address,
                township_id: selectedTownship,
                state_id: selectedState

            }

            callApi('customer/updateCustomer')
                .withKeyParameter({ id: customer_id })
                .withBody(bodyData)
                .loadingGroup('updateCustomer')
                .execute()
                .then(res => {
                    if (res.status === 'success') {
                        onClose()
                        showToast('Customer Updated Successfully', 'success')
                    } else {
                        console.log("error", res)
                        showToast(res?.message ? res?.message : res?.error, 'error')
                    }
                })
                .catch(error => {
                    console.log('Error....', error);
                    showToast(error, 'error')
                });
        }

    })
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            className='flex items-center justify-center'
        >
            <div className={styled.detail_container}>
                <p className={styled.title}>Edit Customer</p>
                <form action="" onSubmit={formik.handleSubmit}>
                    <div className={"mt-[12px]"}>
                        <TextInput
                            name={"name"}
                            type="text"
                            label={"Name"}
                            placeholder={"Enter name"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.name}
                            required
                        />
                        {/* {formik.errors.name && formik.touched.name ? (
                            <p className="text-base text-red-0 mt-[8px]">{formik.errors.name}</p>
                        ) : null} */}
                    </div>
                    <div className={"mt-[12px]"}>
                        <TextInput
                            name={"code"}
                            type="text"
                            label={"Code"}
                            placeholder={"Enter code"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.code}
                            required
                        />
                    </div>
                    <div className={"mt-[12px]"}>
                        <TextInput
                            name={"phone"}
                            type="phone"
                            label={"Phone"}
                            placeholder={"Enter phone number"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.phone}
                            required
                        />
                    </div>
                    <div className={"mt-[12px]"}>
                        <TextInput
                            name={"address"}
                            type="text"
                            label={"Address"}
                            placeholder={"Enter address"}
                            className={"w-full"}
                            onChange={formik.handleChange}
                            value={formik.values.address}
                            required
                        />
                    </div>
                    <div className={"mt-[12px]"}>
                        <InputSelect
                            name={"state"}
                            data={states}
                            label={"State"}
                            className={"w-full"}
                            value={selectedState}
                            onChange={(event) => {
                                const val = states?.find(v => v?.id === event.target?.value)?.township_ids
                                setSelectedState(event.target.value)
                                setSelectedTownship(null)
                                setTownships(val)

                            }}
                            placeholder="Select"
                            required
                        />
                    </div>
                    <div className={"mt-[12px]"}>
                        <InputSelect
                            name={"township"}
                            data={townships}
                            label={"Township"}
                            className={"w-full"}
                            value={selectedTownship}
                            disabled={selectedState ? false : true}
                            onChange={(event) => setSelectedTownship(event.target.value)}
                            placeholder="Select"
                            required
                        />
                    </div>
                    <Button className={styled.button} type="submit">
                        Save
                    </Button>
                </form>
            </div>
        </Modal>
    )
}
export default CustomerEdit